import { SubscriptionInsertDTO } from "./SubscriptionInsertDTO";

export class SubscriptionDTO extends SubscriptionInsertDTO {
    public id: string;
    public createdAt: Date;
    public updatedAt: Date;

    constructor(sub?) {
        super(sub);

        sub = sub || {};

        this.id = sub.id || "";
        this.createdAt = sub.criadoEm || new Date();
        this.updatedAt = sub.atualizadoEm || new Date();
    }
}
